/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Тип заявителя
 * @export
 * @enum {string}
 */
export enum OwnerType {
  IndividualBusinessman = 'INDIVIDUAL_BUSINESSMAN',
  ForeignCompany = 'FOREIGN_COMPANY',
  LegalEntity = 'LEGAL_ENTITY',
  IndividualEntity = 'INDIVIDUAL_ENTITY',
}

export function instanceOfOwnerType(value: any): boolean {
  for (const key in OwnerType) {
    if (Object.prototype.hasOwnProperty.call(OwnerType, key)) {
      if (OwnerType[key as keyof typeof OwnerType] === value) {
        return true
      }
    }
  }
  return false
}

export function OwnerTypeFromJSON(json: any): OwnerType {
  return OwnerTypeFromJSONTyped(json, false)
}

export function OwnerTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): OwnerType {
  return json as OwnerType
}

export function OwnerTypeToJSON(value?: OwnerType | null): any {
  return value as any
}
